class OfferSummary {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields?.id,
      name: this.fields?.name,
      description: this.fields?.description,
      price: this.fields?.productOfferingPrice?.[1]?.retailPrice?.rand?.amount,
      url: this.fields?.attachment?.url
    };
  }
}

export class CatalogueVendor {

  constructor(fields) {

    this.fields = fields;
  }

  mapToStandard() {

    const summaries = [];

    for (let i = 0; i < this.fields?.length; i ++) {

      summaries.push(new OfferSummary(this.fields[i]).mapToStandard());
    }

    return summaries;
  }
}